export default "__VITE_ASSET__Csnqiw1K__"